import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../features/Home/redux/homeSlice";
import megamenuReducer from "../components/Navbars/redux/megaMenuSlice";
import productDetailReducer from "../features/products/pdp/redux/productDetailSlice";
import authReducer from "../features/auth/redux//authSlice";
import cartReducer from "../features/Checkout/Cart/redux/cartSlice";
import wishlistReducer from "../components/Wishlist/WishlistSlice";
import profileReducer from "../pages/Account/Profile/profileSlice";
import addressReducer from "../pages/Account/Profile/addressSlice";
import pincodeReducer from "../features/products/pdp/redux/pincodeSlice";
import checkoutReducer from "../features/Checkout/Summay/redux/checkoutSlice";
import orderHistoryReducer from "../pages/Account/OrderHistory/redux/orderHistorySlice";
import orderDetailReducer from "../features/account/order/redux/orderDetailSlice";
import productReducer from "../features/products/listing/redux/productsSlice";
import promotionsReducer from "../features/products/promotion/redux/promotionsSlice";
import searchProductReducer from "../features/products/search/redux/searchProductSlice";
//searchProductReducer
import topPicksReducer from "../features/products/topPicks/redux/topPicksSlice";
import collectionsReducer from "../features/collection/redux/collectionsSlice";
import contactReducer from "../features/content/contact/redux/contactSlice";
import aboutReducer from "../features/content/about/redux/aboutSlice";
import faqReducer from "../features/content/faq/redux/faqSlice";
import sizeGuideReducer from "../features/content/guides/sizeGuide/redux/sizeGuideSlice";
import styleGuideReducer from "../features/content/guides/styleGuide/redux/styleGuideSlice";
import blogReducer from "../features/content/blog/bloglist/redux/blogSlice";
import policyReducer from "../features/content/policy/redux/policySlice";
import trackShipmentReducer from "../features/content/tracking/redux/trackOrderSlice";
import videoGalleryReducer from "../features/content/gallery/video/redux/videoGallerySlice";
import floorFinderReducer from "../features/products/floorMatcher/redux/FloorMatcherSlice";
// QuickView
import quickviewReducer from "../features/quickView/redux/productsQuickViewSlice";
import bestsellerReducer from "../features/products/promotion/redux/BestsellersBannerSlice";

export const store = configureStore({
  reducer: {
    home: homeReducer,
    megamenu: megamenuReducer,
    products: productReducer,
    promotions: promotionsReducer,
    searchProduct: searchProductReducer,
    topPicks: topPicksReducer,
    productDetail: productDetailReducer,
    quickView: quickviewReducer,
    auth: authReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    profile: profileReducer,
    address: addressReducer,
    floorFinder: floorFinderReducer,
    pincode: pincodeReducer,
    checkout: checkoutReducer,
    orders: orderHistoryReducer,
    orderDetail: orderDetailReducer,
    collections: collectionsReducer,
    contact: contactReducer,
    about: aboutReducer,
    faq: faqReducer,
    sizeGuide: sizeGuideReducer,
    styleGuide: styleGuideReducer,
    blog: blogReducer,
    policy: policyReducer,
    trackOrder: trackShipmentReducer,
    videoGallery: videoGalleryReducer,
    bestseller: bestsellerReducer, // ✅ MUST EXIST
  },
});